import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'prgov-error-register',
  templateUrl: './error-register.component.html',
  styleUrls: ['./error-register.component.scss']
})
export class ErrorRegisterComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ErrorRegisterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }
}
